module.exports = __webpack_public_path__ + "static/media/molorosh_sqr_200.5551ced0.png";